import { createSlotRecipe } from './runtime';

const switchControlConfig = {"name":"switchControl","className":"switch","slots":["root","track","thumb","label"]}

export const switchControl = /* @__PURE__ */ createSlotRecipe(switchControlConfig)